'use client';
import React from 'react';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
export default function WimbledonBridgeAmenities(
  props: MarketingPageComponentProps
) {
  const serviceData =
    props.locale.section?.wimbledonBridgeAmenitiesContent || [];
  return (
    <Stack
      component="section"
      className={cn.wimbledonBridgeAmenities}
      id="wimbledonBridgeAmenitiesID"
    >
      <Box className={cn.wimbledonAmenitiesInner}>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
          flexGrow={1}
        >
          <Box className={cn.wimbledonAmenitiesBody}>
            <Box className={cn.wimbledonAmenitiesHeading}>
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  props.locale.section['wimbledonBridgeAmenitiesHeading']
                )}
              </ParallaxText>
            </Box>
            <Box className={cn.wimbledonAmenitiesContent}>
              <List className={cn.wimbledonAmenitiesList}>
                {serviceData.map((item: any, index: number) => (
                  <ListItem key={index} className={cn.wimbledonAmenitiesItem}>
                    <Box className={cn.wimbledonAmenitiesIcon}>
                      <CustomImage
                        src={item.amenitiesIcon || ''}
                        alt={'Wimbledon Feature Image'}
                        width={768}
                        height={768}
                      />
                    </Box>
                    <Box className={cn.wimbledonAmenitiesText}>
                      <ParallaxText
                        variant="p"
                        animationType="zoomIn"
                        animationDuration={500}
                      >
                        {ReactHtmlParser(item.amenitiesTitle)}
                      </ParallaxText>
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
